{
    "button": {
        "signin": "Sign in",
        "open": "Open",
        "close": "Close",
        "submit": "Submit",
        "previous": "Previous",
        "next": "Next",
        "reset": "Reset",
        "yes": "Yes",
        "no": "No",
        "filter": "Filter",
        "reset_filters": "Reset filters",
        "search": "Search",
        "select_all_page": "Select all page",
        "switch_version": "Bêta version"
    },
    "page": {
        "dashboard": {
            "title": "Dashboard"
        },
        "documentation": {
            "title": "Documentation"
        },
        "envelopes": {
            "title": "Envelopes",
            "tabs": {
                "envelopes": "Envelopes",
                "downloadCodes": "Download Codes"
            }
        },
        "historics": {
            "title": "Historics",
            "tabs": {
                "pos_terminals": "Pos terminals",
                "sim_cards": "SIM cards",
                "users": "Users"
            }
        },
        "home": {
            "title": "Home"
        },
        "merchant_accounts": {
            "title": "Merchant accounts",
            "details": {
                "title": "Merchant account details",
                "tabs": {
                    "merchant_users": "Merchant users",
                    "merchant_contracts": "Merchant contracts",
                    "customization": "Customization",
                    "subscriptions": "Pos terminals",
                    "beneficiaries": "Beneficiaries"
                }
            }
        },
        "newsletter": {
            "title": "News"
        },
        "organization": {
            "title": "{{socialReason}} ($t(organization:type.{{organizationType}}))",
            "short": "Organization details",
            "tabs": {
                "details": "Details",
                "users": "Users",
                "direct_organizations": "Direct organisations",
                "subscriptions": "Pos terminals",
                "remote_collections": "Remittances",
                "parent_plans": "Provider plans",
                "sim_cards": "SIM cards"
            },
            "accordions": {
                "details": "Details",
                "connection_points": "Connection points",
                "legal_infos": "Legal infos",
                "white_label_customization": "White label customization",
                "alerts": "Alerts",
                "sim_offers": "SIM offers"
            }
        },
        "organizations": {
            "title": "Organisations",
            "tree_tmp": "Organizations tree"
        },
        "plans": {
            "title": "Plans catalog",
            "details": {
                "title": "Plan details"
            },
            "accordions": {
                "details": "Plan details",
                "allowed_clients": "Allowed clients"
            }
        },
        "push_payments": {
            "title": "Push Payment API",
            "tabs": {
                "partners": "Partner organizations",
                "notif_rules": "Notifications rules"
            }
        },
        "remote_collection": {
            "title": "Remote collection",
            "details": {
                "title": "Remittance details"
            },
            "transaction": {
                "title": {
                    "full": "Remittance #{{reconciliationNumber}} (contract {{application}} #{{number}})",
                    "without_application": "Remittance #{{reconciliationNumber}} (contract #{{number}})",
                    "without_reconciliation_number": "Remittance (contract {{application}} #{{number}})",
                    "contract_only": "Contract #{{number}}",
                    "short": "Remittance"
                }
            }
        },
        "rentalFiles": {
            "title": "PLBS Files",
            "details": {
                "title": "File #{{fileNumber}}",
                "title_short": "File details",
                "breadcrumb": "#{{fileNumber}}"
            }
        },
        "searchContracts": {
            "title": "Search"
        },
        "sim_cards": {
            "title": "SIM cards",
            "tabs": {
                "sims": "SIM cards",
                "simPools": "SIM groups"
            }
        },
        "sim_card": {
            "title": "SIM card details",
            "details": {
                "full": "n° {{iccid}}",
                "short": "SIM card details"
            }
        },
        "sim_group": {
            "title": "SIM group details"
        },
        "subscription": {
            "title": "Subscription details",
            "details": {
                "full": "n° {{serialNumber}}",
                "short": "Subscription details"
            },
            "tabs": {
                "details": "Details",
                "contracts": "Contracts",
                "connections": "Connections",
                "transactions": "Transactions",
                "remote_collections": "Remittances"
            },
            "accordions": {
                "subscription": "Gateway subscription",
                "terminal": "POS terminal",
                "connection": "Connection",
                "payludd_terminal_state": "Payludd terminal state"
            }
        },
        "subscriptions": {
            "title": "Pos terminals",
            "tabs": {
                "pos_terminals": "Pos terminals",
                "payludd_pos_terminals": "Payludd Pos terminals"
            }
        },
        "users": {
            "title": "Monetic users",
            "details": {
                "title": "Monetic user details"
            },
            "accordions": {
                "details": "User details",
                "permissions": "Permissions"
            }
        },
        "payludd": {
            "customization": {
                "creation": {
                    "title": "New Payludd customization"
                },
                "management": {
                    "title": "Manage Payludd customization"
                },
                "accordions": {
                    "details": "Identifier",
                    "colors": "Colors and logo",
                    "payludd_app_settings": "Functionnalities",
                    "monetic_settings": "Monetic settings"
                }
            }
        }
    },
    "sidebar": {
        "root_organization_helper": "Root organization",
        "menu": {
            "group_1": {
                "label": "Monetics portal",
                "rootEntity": {
                    "configuration": "Settings",
                    "exploitation": "Business",
                    "parc": "Fleet"
                }
            },
            "group_2": {
                "label": "Resources"
            }
        },
        "actions": {
            "manage_user_account": "Manage account",
            "secure_access": "Secure access",
            "login_sign_out": "Sign out",
            "previous": "Previous"
        }
    },
    "date_picker": {
        "before_date": "Before ",
        "after_date": "After ",
        "before_time": "Before {{to}} at",
        "after_time": "After {{from}} at",
        "select_time": "Select a time",
        "from_time": "From {{from}} at",
        "from_time_no_date": "Start date not defined",
        "to_time": "To {{to}} at",
        "to_time_no_date": "End date not defined",
        "local_time_zone": "(pos terminal local time)",
        "options": {
            "before": "Before this date",
            "after": "After this date",
            "select": "Range"
        }
    },
    "number_filter": {
        "filter_by": {
            "amount": "Filter by amount",
            "number": "Filter by quantity"
        },
        "MORE": "Greater than or equal to",
        "LESS": "Less than or equal to",
        "EQUAL": "Equal to",
        "RANGE": {
            "title": "Range",
            "between": "Between",
            "and": "and"
        },
        "badge": {
            "equal": "Equal to {{value}}",
            "more": "Greater than or equal to {{value}}",
            "less": "Less than or equal to {{value}}",
            "range": "Between {{value0}} and {{value1}}"
        }
    },
    "table": {
        "column": {
            "manager": "Column manager"
        },
        "filter": {
            "placeholder": "Select a filter",
            "filter_by": "Select a value"
        },
        "no_results": "No results.",
        "deselect_all": "Deselect all",
        "results": "{{results}} results",
        "pagination": {
            "pageCount": "of {{pageCount}}",
            "rowSelected": "{{rowSelected}} of {{rowCount}} row(s) selected."
        },
        "actions": {
            "export": "Export",
            "import": "Import"
        }
    },
    "select": {
        "default": "Select an option",
        "no_options": "No options available"
    },
    "toast": {
        "loading": "Loading...",
        "success": "Operation succesful",
        "error": "An error as occured"
    },
    "title": {
        "permissions": {
            "access_denied": "You do not have access to this feature"
        },
        "copy": {
            "click": "Click to copy",
            "copied": "Copied"
        }
    },
    "form": {
        "ranks": {
            "free_input": "Invalid format",
            "digits_input": "Invalid format"
        },
        "alma": {
            "api_key": "You must enter an API key",
            "label": "Special characters and accents not allowed"
        },
        "cbvad": {
            "contract_label": "The string is too long!",
            "contract_number": "The contract number must contain between 1 and 15 digits",
            "rank": "The rank must contain exactly 3 digits",
            "bank_code": "The bank code must contain exactly 5 digits",
            "x25_address": "The address must contain a maximum of 50 digits"
        },
        "validation": {
            "email": {
                "invalid": "Please enter a valid email address"
            }
        }
    },
    "modal": {
        "function_not_activated": {
            "text": "Cette fonctionnalité est en cours de développement"
        },
        "send_mail": {
            "maximum_mails": "({{number}} mails maximum)",
            "placeholder": "Enter email here...",
            "already_exists": "This mail alreay exists !",
            "validate": "Validate to finish",
            "add_address": "Add address",
            "remove_address": "Remove address",
            "confirm": {
                "single": "Mail will be sent to the following recipient:",
                "multiple": "Mail will be sent to the following recipients:"
            },
            "steps": {
                "input": "Step {{step}} of {{maxStep}}: Setting emails",
                "confirm": "Step {{step}} of {{maxStep}}: Confirmation"
            }
        },
        "export": {
            "title": "Export these results",
            "emails": "A download link will be sent by mail",
            "link_validity": "link is available for the next 48 hours",
            "sending_confirmation": "Your request has been taken into account. The export will be sent in a few minutes.",
            "error": "An unexpected error occurred. If it occurs again, please contact the technical support."
        },
        "import": {
            "title": "File operations",
            "steps": {
                "file_upload": "Step {{step}} of {{maxStep}}: File upload",
                "confirmation": "Step {{step}} of {{maxStep}}: Confirmation"
            },
            "file_errors": "Errors have been detected in the file."
        }
    },
    "units": {
        "data": {
            "byte": "{{dataUsage}} B",
            "k_byte": "{{dataUsage}} KB",
            "m_byte": "{{dataUsage}} MB",
            "g_byte": "{{dataUsage}} GB"
        }
    },
    "civility": {
        "mr": "Mr",
        "mrs": "Mrs",
        "miss": "Miss"
    },
    "file_upload": {
        "label": "A model with examples is available for download.",
        "default": {
            "file_example": "Download a model",
            "button": "Browse files",
            "cannot_read_file": "Cannot read the file",
            "invalid_file": "Invalid file",
            "invalid_size_file": "File too large"
        }
    },
    "documentation": {
        "api_documentation": "APIs",
        "user_guide": "Monetist guide",
        "user_merchant_guide": "Merchant guide",
        "payludd_guide": "Payludd initialization guide",
        "merchant_payludd_guide": "Merchant operating guide"
    }
}